import {
  Dialog,
  DialogTitle,
  Box,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { cross } from "../../../assets/svgs";
import CustomIconButton from "../../../Components/CustomIconButton";
import SvgPreview from "../../../Components/SvgPreview";
import { rowSB } from "../../../GlobalStyles";
import ReportedDetails from "../ReportedDetails";
import { allApis } from "../../../request/config";
import apiRequest from "../../../request/apiRequest/apiRequest";
import { ObjectValues } from "../../login";
import QuestionPreview from "../../../Components/QuestionPreview";
import MobileEmulator from "../Preview/MobileEmulator";
import { useAppSelecter } from "../../../hooks/storeHooks";

function ReportedQuestionPreview({
  handleDialogClose,
  selectedRow,
  title,
}: any) {
  const [{ questionEditData, load }, setData] = useState<{
    load: boolean;
    questionEditData: ObjectValues;
  }>({ load: true, questionEditData: {} });
  const [selectedLang, setLang] = useState("english");
  const getApi = (id: string) => allApis?.reportQuestion(id);
  const fetchSinlgQustion = async (id: string) => {
    try {
      const response: any = await apiRequest({
        api: getApi(id),
        method: "GET",
        payload: {},
      });
      setData({
        load: false,
        questionEditData: response
          ? {
              ...response,
              languages_available:
                response.translation
                  .map((s: { language: any }) => s.language)
                  .join(",") ?? "english",
            }
          : null,
      });
    } catch (error: any) {
      console.error("API Error:", error); // Add this line to catch and log any errors
      return null;
    }
  };
  const examsData = useAppSelecter((state: ObjectValues) => state.exams);
  const tags_list = examsData.tags_list ?? [];
  useEffect(() => {
    fetchSinlgQustion(selectedRow?.question);
  }, [selectedRow]);
  const formatPayload = (data: any, lang: string) => {
    const newObj: any = {};

    newObj["Question Tags"] = data.tag
      ? tags_list?.filter((item: { id: any }) =>
          data.tag.map((ss: any) => ss.id ?? ss).includes(item.id)
        )
      : [];

    newObj["Explanation"] =
      data.explanation?.translation?.length > 0
        ? data.explanation?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.explanation?.translation?.text ?? "";

    newObj["Option A"] =
      data.options[0]?.translation?.length > 0
        ? data.options[0]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[0]?.translation?.text ?? "";
    if (data.options[0]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option A" };
    }
    newObj["Option B"] =
      data.options[1]?.translation?.length > 0
        ? data.options[1]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[1]?.translation?.text ?? "";
    if (data.options[1]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option B" };
    }
    newObj["Option C"] =
      data.options[2]?.translation?.length > 0
        ? data.options[2]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[2]?.translation?.text ?? "";
    if (data.options[2]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option C" };
    }
    newObj["Option D"] =
      data.options[3]?.translation?.length > 0
        ? data.options[3]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[3]?.translation?.text ?? "";
    if (data.options[3]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option D" };
    }
    newObj["Question"] =
      Array.isArray(data.translation) && data.translation?.length > 0
        ? data.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data?.translation?.text ?? "";

    return newObj;
  };
  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          backdropFilter: "blur(3px)", // subtle blur
        },
      }}
      open={true}
      onClose={handleDialogClose}
      maxWidth="md"
    >
      <DialogTitle
        sx={{
          margin: 0,
          padding: "20px 15px 15px",
          ...rowSB,
          background: "white",
          alignItems: "self-start",
        }}
        id="customized-dialog-title"
      >
        <Box
          sx={
            title
              ? {
                  maxWidth: "445px",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                }
              : {
                  width: "calc(100% - 30px)",
                }
          }
        >
          {selectedRow !== null && selectedRow.id ? (
            <ReportedDetails
              heading="Preview"
              row={selectedRow}
              reportid={selectedRow.id ?? ""}
            />
          ) : title ? (
            title
          ) : (
            "Preview"
          )}
        </Box>
        <Box sx={{ height: "31.33px", alignItems: "center", display: "flex" }}>
          {" "}
          <CustomIconButton
            onClick={handleDialogClose}
            noHover={true}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
            content={<SvgPreview svg={cross} />}
          />
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          height: "calc(100dvh - 123px)",
          minHeight: "calc(100dvh - 123px)",
          boxSizing: "border-box",
          maxWidth: "500px",
          width: "500px",
        }}
      >
        {" "}
        {load ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <MobileEmulator
            submittedData={formatPayload(questionEditData, selectedLang)}
            languge={{
              languages: questionEditData?.languages_available?.includes(
                "hindi"
              )
                ? ["english", "hindi"]
                : ["english"],
              selectedLang: selectedLang,
              handleQuizLanguageToggled: (val) => {
                setLang(val);
              },
            }}
          />
          // <QuestionPreview
          //   questionPreviewData={questionEditData as any}
          //   language_available={questionEditData?.languages_available}
          // />
        )}{" "}
      </DialogContent>
    </Dialog>
  );
}

export default ReportedQuestionPreview;
